import {IKeyValuePair, IResourcePath} from "./common";
import {Utils} from "../common/utils";
import {isNullOrUndefined} from "util";
export const TOPOLOGY_LLC: string = 'llc';
export const TOPOLOGY_BUCK: string = 'buck';
export const TOPOLOGY_BOOST: string = 'boost';
export const TOPOLOGY_FLYBACK: string = 'flyback';
export const TOPOLOGY_PFC_BOOST: string = 'pfc boost';
export const TOPOLOGY_BUCK_BOOST: string = 'buck-boost';
export const TOPOLOGY_QR_FLYBACK: string = 'qr flyback';
export const TOPOLOGY_ISOLATED_BUCK: string = 'isolated buck';
export const TOPOLOGY_HPF_QR_FLYBACK: string = 'hpf qr flyback';
export const TOPOLOGY_FLOATING_BOOST: string = 'floating boost';
export const TOPOLOGY_ISOLATED_FLYBACK: string = 'isolated flyback';
export const TOPOLOGY_POSITIVE_BUCK_BOOST: string = 'positive buck-boost';
export const TOPOLOGY_FLOATING_BUCK_BOOST: string = 'floating buck-boost';
export const TOPOLOGY_NON_ISOLATED_FLYBACK: string = 'non isolated flyback';
export const TOPOLOGY_INVERTING_BUCK_BOOST: string = 'inverting buck-boost';

export const APP_CLASS_ACDC: string = 'acdc';
export const APP_CLASS_DCDC: string = 'dcdc';
export const APP_CLASS_LED_ACDC: string = 'led_acdc';
export const APP_CLASS_LED_DCDC: string = 'led';

export enum MainViewType {
  GRID = 0,
  LIST = 1
}

export enum SortDirectionType {
  ASCEND = 1,
  DESCEND = -1
}

export  const ADD_OUTPUT: IKeyValuePair = {key: 'addOutput'};
export  const REMOVE_OUTPUT: IKeyValuePair = {key: 'removeOutput'};

export function getResourceImagePath(res: string, fileInfo: IResourcePath): string {
  const _fileName: string = Utils.getFieldValue(fileInfo, "name");
  const _path: string = Utils.getFieldValue(fileInfo, "path", "");
  const _pathName: string = _path + (_path.endsWith("/") ? '' : '/') + _fileName;
  const _res = _fileName.endsWith('.svg') ? 'svg' : res;

  return "assets/images/" + _res + "/" + _pathName;
}

export function isResourceImageAvailable(res: string, fileInfo: IResourcePath): boolean {
  return !isNullOrUndefined(fileInfo) && !isNullOrUndefined(fileInfo.name) && (fileInfo.name.endsWith('.png') || fileInfo.name.endsWith('.svg'));
}
